import { ATTRITION_STATUS, type AttritionRequestListItem } from './attritionTypes';

/**
 * Documents approved and units cleared, over every line the request asks for — the ONE source of
 * the fraction both registers' ring and `Progress` column read (HR's and Self Service's). Both
 * kinds count because a request completes only on both: documents alone would read 100% on a
 * request still waiting on a unit. A cancelled request is outside the question, so it has none
 * rather than a stalled one.
 */
export function approvalOf(row: AttritionRequestListItem): { done: number; total: number } | null {
  if (row.status === ATTRITION_STATUS.cancelled || row.documentCount <= 0) return null;

  return { done: row.approvedCount + row.clearedCount, total: row.documentCount + row.clearanceCount };
}
